import { createRef } from "react";

export const toastRef = createRef();

export const showToast = (message, duration = 3000) => {
  toastRef.current?.addToast(message, duration);
};
